import { render, staticRenderFns } from "./Identify.vue?vue&type=template&id=e86e93f2&scoped=true"
import script from "./Identify.vue?vue&type=script&lang=js"
export * from "./Identify.vue?vue&type=script&lang=js"
import style0 from "./Identify.vue?vue&type=style&index=0&id=e86e93f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86e93f2",
  null
  
)

export default component.exports